import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
import { useEffect, useState } from 'react';
import once from 'transmute/once';
import { DEAL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
const portalId = PortalIdParser.get();
const BASE_PATH = `hubs-settings/v1/hubs/${portalId}/settings`;
export const getIsDealSplitsEnabled = once(() => http.get(`${BASE_PATH}/Forecasting:DealSplits:Enabled`, {
  query: {
    internal: false
  }
}));
export const useIsDealSplitsEnabled = objectType => {
  const [isDealSplitsEnabled, setIsDealSplitsEnabled] = useState(false);
  useEffect(() => {
    if (objectType === DEAL_TYPE_ID) {
      getIsDealSplitsEnabled().then(data => {
        setIsDealSplitsEnabled(!!data);
      }).catch(() => {
        setIsDealSplitsEnabled(false);
      });
    }
  }, [objectType]);
  return isDealSplitsEnabled;
};